import { Text } from "@mantine/core";
import { Stack } from "@mantine/core";
import React from "react";

type Props = {
  label: string;
  error?: string;
} & (
  | {
      text: string;
    }
  | {
      children: React.ReactNode;
    }
);

export const LabelledValue = ({ label, error, ...props }: Props) => {
  return (
    <Stack gap={0} w="fit-content">
      <Text fw={750} tt="uppercase" size="sm" c="gray">
        {label}
      </Text>
      {"text" in props ? <Text fw={500}>{props.text}</Text> : props.children}
      {error && (
        <Text c="red" size="sm">
          {error}
        </Text>
      )}
    </Stack>
  );
};
